// extracted by mini-css-extract-plugin
export default {"offersList":"offersList_PcEFX","list":"list_LuT4D","showMore":"showMore_MLXT4"};